<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" :text="$t('button.add')" position="top">
                <feather-icon icon="PlusIcon" class="action-success icon-btn mt-3"
                    svg-classes="h-5 w-5 hover:text-primary cursor-pointer" @click="addQuestion">
                </feather-icon>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.details')" position="top">
                <feather-icon icon="EyeIcon" class="action-success icon-btn mt-3"
                    svg-classes="h-5 w-5 hover:text-primary cursor-pointer" @click="openUpdateTopic">
                </feather-icon>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top">
                <feather-icon icon="TrashIcon" class="action-err icon-btn mt-3"
                    svg-classes="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteCategory">
                </feather-icon>
            </vx-tooltip>
        </div>
        <vs-popup :title="this.$t('multipleChoice.updated')" :active.sync="popupActiveUse">
            <div class="vx-col ">
                <label class="vs-input--label required">{{ $t('multipleChoice.category') }}</label>
                <v-select class="" v-model="topic.categoryId" :clearable="false" :options="categoryOptions"
                    :reduce="(option) => option.value">
                </v-select>
            </div>
            <div class="vx-row mt-2">
                <div class="vx-col md:w-full">
                    <label class="vs-input--label required">{{ $t('multipleChoice.topic') }}</label>
                    <vs-input class="w-full" v-model="topic.topicName" type="text" data-vv-validate-on="blur" />
                </div>
            </div>
            <div class="vx-row mt-2">
                <div class="vx-col md:w-full">
                    <label class="vs-input--label required">{{ $t('multipleChoice.semester') }}</label>
                    <vs-input class="w-full" v-model="topic.semester" type="text" data-vv-validate-on="blur" />
                </div>
            </div>
            <div class="vx-col w-full mt-2">
                <div class="mt-2 flex flex-wrap items-center justify-end mb-2">
                    <vs-button class="float-right mr-5" @click="updateTopic">{{ $t('multipleChoice.updated') }}</vs-button>
                </div>
            </div>
        </vs-popup>
    </div>
</template>
<script>
import vSelect from 'vue-select';
import questionInfo from "../QuestionInfo.vue"
export default {
    name: 'CellRendererTopicSet',
    components: {
        vSelect,
        questionInfo
    },
    data() {
        return {
            popupActiveUse: false,
            topic: {
                topicName: null,
                semester: null,
                categoryId: null,
            },
            categoryOptions: []
        }
    },
    methods: {
        addQuestion() {
            this.$router.push(`/user/multiple-topic-set-question?topicId=${this.params.data.id}`);
        },
        getCategory() {
            let body = {
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,

            }
            this.$crm.post('/school-quiz-category/find-by-condition', body).then((response) => {
                this.categoryOptions = response.data.content.map(el => {
                    return {
                        label: el.categoryName,
                        value: el.id
                    }
                })
            })
        },
        openUpdateTopic() {
            this.topic.topicName = this.params.data.topicName;
            this.topic.semester = this.params.data.semester;
            this.topic.categoryId = this.params.data.categoryId;
            this.popupActiveUse = true;
            this.getCategory();
        },
        updateTopic() {
            if (!this.topic.topicName || !this.topic.semester || !this.topic.categoryId) {
                return this.$vs.notify({
                    text: 'Vui lòng nhập đầy đủ thông tin',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning',
                })
            }
            this.$vs.loading();
            this.$crm.post(`/school-quiz-topic/update/${this.params.data.id}`, this.topic).then((response) => {
                this.$vs.loading.close();
                this.popupActiveUse = false;
                this.$store.commit('DELETE_TOPICSET', true)
                return this.$vs.notify({
                    text: 'Cập nhật bộ đề thành công',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success',
                });
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        confirmDeleteCategory() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: 'Xác nhận xoá',
                text: `Bạn có chắc là muốn xoá danh mục "${this.params.data.topicName}" không? `,
                accept: this.deleteCategory,
                acceptText: 'Xoá',
                cancelText: 'Huỷ',
            })
        },
        deleteCategory() {
            this.$vs.loading();
            this.$crm.post(`/school-quiz-topic/delete/${this.params.data.id}`).then((response) => {
                this.$vs.loading.close();
                this.$store.commit('DELETE_TOPICSET', true)
                return this.$vs.notify({
                    text: 'Xóa danh mục thành công',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success',
                });
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        mounted() {
            this.$eventBus.$on('', () => {
                this.$store.commit('DELETE_TOPICSET', true)
            })
        }
    },
}
</script>
<style>
.required::after {
    content: '* ';
    color: red;
}
</style>
